import WaveSurfer from 'wavesurfer.js';
import $ from 'jquery';
let wavesurfer, playerIndex, currentIndex;

export function init_musicPlayer() {
    
    [...document.querySelectorAll('.js-player')].forEach(item => { 
        $(item).find('.js-play').on('click', play.bind(this));
    });

    function play(e) {
        e.preventDefault();
        let trigger = $(e.currentTarget);
        let parent = trigger.parents('.js-player'); 

        playerIndex = trigger.data('player-index');
        
        if(playerIndex != currentIndex) {
            if(wavesurfer) {
                wavesurfer.destroy();
                $('.js-play').text('Listen');
            }

            wavesurfer = WaveSurfer.create({
                container: parent.find('.js-wave-form')[0],
                waveColor: '#c1c1c1',
                progressColor: '#939393',
                barHeight: 1,
                height: 35,
                responsive: true,
            });
            wavesurfer.load(`${trigger.attr('href')}`);
            wavesurfer.on('ready', function () {
                wavesurfer.playPause();
                if(parent.find('wave').length && wavesurfer.isPlaying()) {
                    trigger.text('Pause');
                }
            });
        } else {
            wavesurfer.playPause();
            if(parent.find('wave').length && wavesurfer.isPlaying()) {
                trigger.text('Pause');
            } else {
                trigger.text('Play');
            }
        }

        currentIndex = trigger.data('player-index');

        wavesurfer.on('finish', function () {
            wavesurfer.destroy();
            $('.js-play').text('Listen');
        });
        
    }

}



// WEBPACK FOOTER //
// ./resources/assets/js/scripts/music-player.js